/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useEffect, useState } from 'react';
import { agentShortcutModifierKey } from '../../keyboard';

// True while the platform agent modifier (Ctrl on macOS, Alt on Windows/Linux)
// is held. Drives the fade-in of shortcut hints across the agent surfaces.
export function useAgentModifierHeld() {
  const [held, setHeld] = useState(false);
  useEffect(() => {
    const modifierKey = agentShortcutModifierKey();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === modifierKey) setHeld(true);
    };
    const onKeyUp = (event: KeyboardEvent) => {
      if (event.key === modifierKey) setHeld(false);
    };
    const reset = () => setHeld(false);
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    window.addEventListener('blur', reset);
    document.addEventListener('visibilitychange', reset);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', reset);
      document.removeEventListener('visibilitychange', reset);
    };
  }, []);
  return held;
}
